
import { PublicHermandadesClient } from '@/components/hermandades/PublicHermandadesClient';
import { db } from "@/firebase/config";
import { JartinetHermandad } from "@/lib/types";
import { collection, getDocs, orderBy, query, onSnapshot } from 'firebase/firestore';
import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { sanitizeFirestoreData } from "@/lib/utils";

export default function HermandadesPage() {
  const [hermandades, setHermandades] = useState<JartinetHermandad[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Set up a real-time listener for the 'jartinet_hermandades' collection
    const q = query(collection(db, "jartinet_hermandades"), orderBy("nombre", "asc"));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const hermandadesData = querySnapshot.docs.map(doc => sanitizeFirestoreData({ id: doc.id, ...doc.data() })) as JartinetHermandad[];
      setHermandades(hermandadesData);
      setLoading(false);
    }, (error) => {
      console.error("Error fetching hermandades for public page:", error);
      setLoading(false);
    });

    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, []);
  
  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader2 className="h-16 w-16 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <main>
      <PublicHermandadesClient initialHermandades={hermandades} />
    </main>
  );
}
